var levelMeta = [
	{
		category: 1,
		points:0,
		boldTitle: 'Ojda!',
		title: 'Er du sikker på at du er en markedsfører?',
		intro: `<p>Har du vært markedsfører hele livet? Vi antar at du høyst sannsynlig liker å kommunisere med andre mennesker, holder deg oppdatert i bransjen, samt har gode analytiske egenskaper. Vi kunne gjerne ønske å jobbe sammen med deg. Klikk på knappen nedenfor for å se hva vi kan tilby.</p>`,
	},
	{
		category: 2,
		points:2,
		boldTitle: 'Bra jobba!',
		title: 'Du må være en god markedsfører.',
		intro: `<p>Har du vært markedsfører hele livet? Vi antar at du høyst sannsynlig liker å kommunisere med andre mennesker, holder deg oppdatert i bransjen, samt har gode analytiske egenskaper. Vi kunne gjerne ønske å jobbe sammen med deg. Klikk på knappen nedenfor for å se hva vi kan tilby.</p>`,
	},
	{
		category: 3,
		points:10,
		boldTitle: 'Herlig!',
		title: 'Det er tydelig at du er en erfaren markedsfører.',
		intro: `<p>Har du vært markedsfører hele livet? Vi antar at du høyst sannsynlig liker å kommunisere med andre mennesker, holder deg oppdatert i bransjen, samt har gode analytiske egenskaper. Vi kunne gjerne ønske å jobbe sammen med deg. Klikk på knappen nedenfor for å se hva vi kan tilby.</p>`,
	},
	{
		points:17,
		category: 4,
		boldTitle: 'Nydelig!',
		title: 'Du er jo en ekspert på alle områder.',
		intro: `<p>Har du vært markedsfører hele livet? Vi antar at du høyst sannsynlig liker å kommunisere med andre mennesker, holder deg oppdatert i bransjen, samt har gode analytiske egenskaper. Vi kunne gjerne ønske å jobbe sammen med deg. Klikk på knappen nedenfor for å se hva vi kan tilby.</p>`,
	}
];

export default levelMeta;


// WEBPACK FOOTER //
// ./src/appdata/results.js